export default __webpack_public_path__ + "static/media/edit.0d0e8e0e.svg";